var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid abacus-oo-giftcards p-0 mobile-wrapper"},[(_vm.isMobile())?_c('div',[_c('ShopHeaderMobile',{attrs:{"storeid":_vm.storeid,"isGiftCard":true}})],1):_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col"},[_c('ShopHeader',{attrs:{"storeid":_vm.storeid}})],1)]),_c('div',{class:[
      'row',
      'no-gutters',
      'justify-content-md-center',
      _vm.isMobile() ? 'margin-top-nav' : 'pt-4',
    ]},[_c('div',{staticClass:"col-xs-12 col-md-8"},[_c('div',{staticClass:"container abacus-oo-giftcards-main p-0"},[_c('router-view',{attrs:{"menuLoaded":_vm.menuLoaded}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }